import 'regenerator-runtime/runtime'; // fix console error 'Uncaught ReferenceError: regeneratorRuntime is not defined'
import autoComplete from "@tarekraafat/autocomplete.js";

document.addEventListener('DOMContentLoaded', () => {

    const searhInput = document.querySelectorAll('.js-search-input');
    searhInput.forEach((item, index) => {

        const parent = item.closest('.search');
        const searchClear = parent?.querySelector('.js-search-clear');

        item.addEventListener('input',()=>{
            if(item.value.length>0){
                item.classList.add('search__input--filled');
                searchClear?.classList.add('search__clear--active');
            }
            else{
                item.classList.remove('search__input--filled');
                searchClear?.classList.remove('search__clear--active');
            }
        });

        if(item.getAttribute('data-autocomplete')){
            item.setAttribute('id','autocomplete-'+index);
            item.setAttribute('autocomplete','off');
            const dataJson = item.getAttribute('data-autocomplete');
            const autoCompleteJS = new autoComplete({
                selector: '#autocomplete-'+index,
                data: {
                    src: async (query:any) => {
                        try {
                            const source = await fetch(dataJson+'?q='+query);
                            const data = await source.json();
                            return data;
                        } catch (error) {
                            return error;
                        }
                    }
                },
                resultItem: {
                    highlight: true,
                },
                events: {
                    input: {
                        selection: (event) => {
                            const selection = event.detail.selection.value;
                            autoCompleteJS.input.value = selection;
                            autoCompleteJS.input.dispatchEvent(new Event('change'));
                        }
                    }
                }
            });
        }

    });

    const searhClear = document.querySelectorAll('.js-search-clear');
    searhClear.forEach((item, index) => {
        item.addEventListener('click',()=>{
            const input = item.parentNode.querySelector('.js-search-input');
            item.classList.remove('search__clear--active');
            if (typeof input !== 'undefined' && input !== null) {
                input.value = '';
                input.classList.remove('search__input--filled');
                input.focus();
            }
        });
    });

});
